import { BRAND_HOSTS, Brands } from 'src/app/shared/constants/brands.constants';

export function configureHost(brand: Brands = Brands.REGUS): string {
  const isLocalhost = /localhost|localdev/i.test(location.host);

  if (isLocalhost) {
    return BRAND_HOSTS[brand];
  }

  return location.host;
}
